import { ReactNode } from 'react'
import { Sheet, SheetContent } from '@/components/ui/sheet'

interface MobileDrawerProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  children: ReactNode
}

export const SecondarySidebarMobileDrawer = ({
  isOpen,
  onOpenChange,
  children,
}: MobileDrawerProps) => {
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent
        side="left"
        className="w-full p-0 overflow-hidden"
        data-slot="MobileSecondaryDrawer"
        aria-label="Project navigation drawer"
      >
        {children}
      </SheetContent>
    </Sheet>
  )
}
